package org.solyton.solawi.bid.module.user.`data`.user

import kotlin.String
import kotlin.collections.List
import org.evoleq.axioms.definition.ReadOnly
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.module.permissions.`data`.Permissions
import org.solyton.solawi.bid.module.user.`data`.organization.Organization
import org.solyton.solawi.bid.module.user.`data`.profile.UserProfile

/**
 * Autogenerated Lens.
 * Read and manipulate [User.username]
 */
@ReadWrite
public val username: Lens<User, String> by lazy {
      Lens(
        get = { whole -> whole.username },
        set = { part -> { whole -> whole.copy(username = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [User.username]
 */
@ReadWrite
public fun User.username(`set`: String.() -> String): User = copy(username = set(username))

/**
 * Autogenerated Lens.
 * Read and manipulate [User.password]
 */
@ReadWrite
public val password: Lens<User, String> by lazy {
      Lens(
        get = { whole -> whole.password },
        set = { part -> { whole -> whole.copy(password = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [User.password]
 */
@ReadWrite
public fun User.password(`set`: String.() -> String): User = copy(password = set(password))

/**
 * Autogenerated Lens.
 * Read and manipulate [User.accessToken]
 */
@ReadWrite
public val accessToken: Lens<User, String> by lazy {
      Lens(
        get = { whole -> whole.accessToken },
        set = { part -> { whole -> whole.copy(accessToken = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [User.accessToken]
 */
@ReadWrite
public fun User.accessToken(`set`: String.() -> String): User = copy(accessToken = set(accessToken))

/**
 * Autogenerated Lens.
 * Read and manipulate [User.refreshToken]
 */
@ReadWrite
public val refreshToken: Lens<User, String> by lazy {
      Lens(
        get = { whole -> whole.refreshToken },
        set = { part -> { whole -> whole.copy(refreshToken = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [User.refreshToken]
 */
@ReadWrite
public fun User.refreshToken(`set`: String.() -> String): User = copy(refreshToken =
    set(refreshToken))

/**
 * Autogenerated Lens.
 * Read and manipulate [User.profile]
 */
@ReadWrite
public val profile: Lens<User, UserProfile?> by lazy {
      Lens(
        get = { whole -> whole.profile },
        set = { part -> { whole -> whole.copy(profile = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [User.profile]
 */
@ReadWrite
public fun User.profile(`set`: UserProfile?.() -> UserProfile?): User = copy(profile = set(profile))

/**
 * Autogenerated ReadOnly Lens.
 * Read [User.permissions]
 */
@ReadOnly
public val permissions: Lens<User, Permissions> by lazy {
      Lens(
        get = { whole -> whole.permissions },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [User.organizations]
 */
@ReadWrite
public val organizations: Lens<User, List<Organization>> by lazy {
      Lens(
        get = { whole -> whole.organizations },
        set = { part -> { whole -> whole.copy(organizations = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [User.organizations]
 */
@ReadWrite
public fun User.organizations(`set`: List<Organization>.() -> List<Organization>): User =
    copy(organizations = set(organizations))
